import React from 'react'
import styled from 'styled-components';

import {colorPalette} from '../Config/colorConfig.js'

import NXV1270A from "../images/machine/01_NXV1270A.png";
import NFX400AMPS from "../images/machine/02_NFX400A-MPS.png";
import UV650 from "../images/machine/03_UV650.png";
import NTC2000LSY from "../images/machine/04_NTC-2000LSY.png";
import NSV106AMS from "../images/machine/05_NSV106AMS.png";
import DCV2012B from "../images/machine/06_DCV2012B.png";
import NFP500A5AX from "../images/machine/07_NFP500A-5AX.png";
import DCV2018A5AX from "../images/machine/08_DCV-2018A-5AX.png";
import NFP66A from "../images/machine/09_NFP66A.png";
import NXV600A from "../images/machine/10_NXV-600A.png";
import NSV106AS from "../images/machine/11_NSV106AS.png";
import NH500AW from "../images/machine/12_NH500AW.png";

//×
//ar的url在public資料夾，路徑較特別

const BlueText = styled.span`
    color: ${colorPalette.myBlue}
`

const machineConfig = {
    //填充頁
    TEST:{
    ch:
    {   title:'(T)',
        subtitle:'(T)',
        ar:'',
        machineImg:'',
        introduction:[  '(T)',
                        '(T)',
                        '(T)',
                        '(T)',
                        '(T)'
                    ],
        videoUrl:"",
        buttonVideoUrl:"",
        moreInfo:"",
        onlineDemo:"",
        specification:[
                ['(T)','(T)'],
                ['(T)','(T)'],
                ['(T)','(T)'],
                ['(T)','(T)'],
                ['(T)','(T)'],
                ['(T)','(T)'],
                ['(T)','(T)'],
            ],
        // annotation:[
        //     ['(T)'],
        // ],
    },
    en:
    {   title:'(TEN)',
        subtitle:'(TEN)',
        ar:'',
        machineImg:'',
        introduction:[  '(TEN)',
                        '(TEN)',
                        '(TEN)',
                        '(TEN)',
                        '(TEN)'
                    ],
        videoUrl:"",
        buttonVideoUrl:"",
        moreInfo:"",
        onlineDemo:"",
        specification:[
                ['(TEN)','(TEN)'],
                ['(TEN)','(TEN)'],
                ['(TEN)','(TEN)'],
                ['(TEN)','(TEN)'],
                ['(TEN)','(TEN)'],
                ['(TEN)','(TEN)'],
                ['(TEN)','(TEN)'],
            ],
        // annotation:[
        //     ['(TEN)'],
        // ],
    }
    },
    //NFX 400A- MPS
    NFX400AMPS:{
    ch:
    {   title:'NFX 400A-MPS',
        subtitle:'高效率五軸立式加工機',
        ar:'',
        machineImg:NFX400AMPS,
        introduction:[  '三軸皆採用以伺服馬達直結驅動滾珠螺桿，快速進給速度更可高達 36 m/min。',
                        '搭配MPS，最大可加工 ø400 × 210 mm 及 155 kg 工件。',
                        '標準24T，另可因應加工需求，選擇搭配 30T、40T、60T。',
                        '搭配多盤面自動交換工作台系統，提升極致的生產效能及加工效益。',
                        <div>
                        <p>自動化特色</p>
                        <p>- 適合少量多樣生產模式，單件也可生產</p>
                        <p>- 坪效應用最佳化</p>
                        <p>- 搭配6盤倉儲</p>
                        <p>- 結合工作台管理系統</p>
                        </div>
                    ],
        videoUrl:"https://www.youtube.com/watch?v=MGbyHOzZGss&feature=youtu.be",
        buttonVideoUrl:"https://youtu.be/UdziKCOcxjc",
        moreInfo:"https://www.ycmcnc.com/product/1532483513218/1533204778416/1576484021219",
        onlineDemo:"https://www.ycmcnc.com/_upload/files/NFX400A_C_2019_low.pdf",
        specification:[
                ['主軸轉速(選擇)','12,000 (15,000) rpm'],
                ['最大主軸功率(選擇)','18.5 (22) kW'],
                ['主軸端孔斜度','BBT40'],
                ['X / Y / Z軸行程','650 / 520 / 480 mm'],
                ['A / C軸旋轉範圍','+30°~ -120° / ±360°'],
                ['工作台尺寸',<span>ø350 mm<br/>(可加工範圍 ø400 x 210 mm)</span>],
                ['刀具數量(選擇)','24 (30 / 40 / 60) T'],
            ],
        // annotation:[
        //     ['註：本公司隨時進行研究改進的工作，因此保有更改設計、規格功能之權利。'],
        // ],
    },
    en:
    {   title:'NFX 400A-MPS',
        subtitle:<span>High Productivity Full 5-Axis<br/>Vertical Machining Center</span>,
        ar:'',
        machineImg:NFX400AMPS,
        introduction:[  <span>High precision ball screws on X/Y/Z-axis directly driven by servomotor, providing rapid feedrate up to 36 m/min. <BlueText>1,417 ipm.</BlueText></span>,
                        <span>Max. workpiece size of up to ø400 × 210 mm <BlueText>ø15.8"×8.3"</BlueText> with up to 155 kg <BlueText>341 lb</BlueText> weight (with MPS) .</span>,
                        'Wide selection of tool magazine, including 24T(std.) , 30T / 40T / 60T (opt.)',
                        'High productivity multi-pallet system (opt.)',
                        <div>
                        <p>Application</p>
                        <p>- Best for small batch production</p>
                        <p>- The most profitable solution in sales per unit area.</p>
                        <p>- Reliable automatic 6 pallets changer</p>
                        <p>- Enable effective pallet management</p>
                        </div>
                        ,
                    ],
        videoUrl:"https://www.youtube.com/watch?v=MGbyHOzZGss&feature=youtu.be",
        buttonVideoUrl:"https://youtu.be/UdziKCOcxjc",
        moreInfo:"https://www.ycmcnc.com/en/product/1532483513218/1533204778416/1576484021219",
        onlineDemo:"https://www.ycmcnc.com/_upload/files/NFX400A_E_2019_low.pdf",
        specification:[
                ['Spindle Speed (opt.)','12,000 (15,000) rpm'],
                ['Max. Spindle Power (opt.)',<span>18.5 (22) kW <BlueText>25 (30) HP</BlueText></span>],
                ['Spindle Taper','BBT40'],
                ['X / Y / Z-axis',<span>650 / 520 / 480 mm<br/><BlueText>25.6" / 20.5" / 18.9"</BlueText></span>],
                ['A / C-axis Rotation Range','+30°~ -120° / ±360°'],
                ['Table Size',<span>ø350 mm<br/><BlueText>ø13.8"</BlueText></span>],
                ['Tool Magazine Capacity (opt.)','24 (30 / 40 / 60) T'],
            ],
        // annotation:[
        //     ['The manufacturer reserves the right to modify the design, specifications, mechanisms, etc. to improve the performance of the machine without notice. All the specifications shown above are just for reference.'],
        // ],
    }
    },
    //NFP 500A- 5AX
    NFP500A5AX:{
    ch:
        {   title:'NFP 500A-5AX',
            subtitle:'小龍門五軸同動立式加工機',
            ar:['Ar/iFrame/machineContent_NFP500A_Ch.html',
                'Ar/iFrame/machineShow_NFP500A.html'],
            machineImg:NFP500A5AX,
            introduction:[  'X/Y軸採用 55 mm / Z軸 45 mm 滾柱線軌，並以AC伺服馬達驅動大直徑滾珠螺桿，快速進給速度可高達 50 m/min。',
                            'X軸採六滑塊設計，全行程支撐五軸台，達到極致的動態水平。',
                            '高扭力、高精度A/C軸旋轉工作台，最大可加工 Ø650 × 400 mm 及載重達 300 kg 之工件。',
                            '完整熱對策，有效降低熱變位影響，實現完美高精度。(選擇)'
                        ],
            videoUrl:"https://www.youtube.com/watch?v=FXDnqtuTPTk&feature=youtu.be",
            buttonVideoUrl:"",
            moreInfo:"https://www.ycmcnc.com/new/1533009146757/1604285431910",
            onlineDemo:"https://www.ycmcnc.com/_upload/NFP%20500A-5AX_C_202009_low.pdf",
            automation:"",
            specification:[
                    ['主軸轉速(選擇)','24,000 (18,000) rpm'],
                    ['最大主軸功率(選擇)','22.5 (18 / 22.5) kW'],
                    ['主軸端孔斜度','HSK A63 (HSK A63 / BBT 40)'],
                    ['X / Y / Z軸行程','850 / 1,200 / 500 mm'],
                    ['A / C軸旋轉範圍','±120° / 360°'],
                    ['工作台尺寸','ø500 mm'],
                    ['刀具數量(選擇)','60 (40 / 80 / 160) T'],
                ],
            // annotation:[
            //     ['註：本公司隨時進行研究改進的工作，因此保有更改設計、規格功能之權利。'],
            // ],
        },
        en:
        {   title:'NFP 500A-5AX',
            subtitle:'Full 5-Axis Double Column Vertical Machining Center',
            ar:['Ar/iFrame/machineContent_NFP500A_En.html',
                    'Ar/iFrame/machineShow_NFP500A.html'],
            machineImg:NFP500A5AX,
            introduction:[  <span>Large-diameter ball screws on X/Y/Z-axis directly driven by servomotor, providing rapid feedrate up to 50 m/min. <BlueText>1,969 ipm.</BlueText></span>,
                            '6 slide blocks on X-axis.',
                            <span>High torque A/C-axis rotary table can holds a max. workpiece size of ø650 × 400 mm ø25.6" × 15.8" with 300 kg <BlueText>660 lb</BlueText> weight.</span>,
                            'Complete thermal solutions against thermal deformation achieve excellent cutting performance.(opt.)',
                        ],
            videoUrl:"https://www.youtube.com/watch?v=FXDnqtuTPTk&feature=youtu.be",
            buttonVideoUrl:"",
            moreInfo:"https://www.ycmcnc.com/en/new/1533009146757/1604285431910",
            onlineDemo:"https://www.ycmcnc.com/_upload/NFP%20500A-5AX_E_202009_low.pdf",
            automation:"",
            specification:[
                    ['Spindle Speed (opt.)','24,000 (18,000) rpm'],
                    ['Max. Spindle Power (opt.)',<span>22.5 (18 / 22.5) kW<br/><BlueText>30 (24 / 30)HP</BlueText></span>],
                    ['Spindle Taper','HSK A63 (HSK A63 / BBT 40)'],
                    ['X / Y / Z-axis',<span>850 / 1,200 / 500 mm<br/><BlueText>33.5" / 47.3" / 19.7"</BlueText></span>],
                    ['A / C-axis Rotation Range','±120° / 360°'],
                    ['Table Size',<span>ø500 mm<br/><BlueText>ø19.7"</BlueText></span>],
                    ['Tool Magazine Capacity (opt.)','60 (40 / 80 / 160) T'],
                ],
            // annotation:[
            //     ['The manufacturer reserves the right to modify the design, specifications, mechanisms, etc. to improve the performance of the machine without notice. All the specifications shown above are just for reference.'],
            // ],
        }
    },
    //UV 650
    UV650:{
        ch:
            {   title:'UV 650-Flexcell',
                subtitle:'高性能五軸立式加工機',
                ar:['Ar/iFrame/machineContent_UV650_Ch.html',
                    'Ar/iFrame/machineShow_UV650.html'],
                machineImg:UV650,
                introduction:[  '獨特IDD直結式主軸設計，能在高速運轉下提供完美加工表面精度。',
                                'B/C軸旋轉工作台標準配有光學尺，滿足高精度加工的嚴苛考驗。',
                                '大盤面旋轉工作台，最大可載重達300 kg (0°~45°) / 200 kg (45°~90°)之工件，提供寬敞的加工空間安裝夾治具。',
                                '宜人性設計，有利於操作者清潔、量測、上下工件及刀具，提升機台操作方便性。',
                                '右側門可選配自動門，搭配自動化設備使用。'
                            ],
                videoUrl:"https://www.youtube.com/watch?v=9xHFNXUiT_s&feature=youtu.be",
                // buttonVideoUrl:"https://www.google.com/",
                moreInfo:"https://www.ycmcnc.com/new/1533009146757/1644542174129",
                onlineDemo:"http://www.ycmcnc.com/_upload/files/UV_650_202009_C_low.pdf",
                // automation:"https://www.google.com/",
                specification:[
                        ['主軸轉速(選擇)','12,000 (15,000)rpm'],
                        ['最大主軸功率(選擇)','17 (17) kW'],
                        ['主軸端孔斜度','BBT 40'],
                        ['X / Y / Z軸行程','620 / 520 / 460 mm'],
                        ['B / C軸旋轉範圍','-50°~ +110° / 360°'],
                        ['工作台尺寸','ø650 mm'],
                        ['刀具數量(選擇)','32 (40 / 48 / 60)T'],
                    ],
                // annotation:[
                //     ['註：本公司隨時進行研究改進的工作，因此保有更改設計、規格功能之權利。'],
                // ],
            },
        en:
            {   title:'UV 650-Flexcell',
                subtitle:'Full 5-Axis Vertical Machining Center',
                ar:['Ar/iFrame/machineContent_UV650_En.html',
                    'Ar/iFrame/machineShow_UV650.html'],
                machineImg:UV650,
                introduction:[  'The YCM in-house IDD spindle design provides power, speed, and stiffness required for the most adverse machining applications while providing long spindle life.',
                                'High precision rotary encoders in the B and C axes as a standard feature, allowing for the most demanding machining accuracies.',
                                'ø650 mm ø25.5" 2-axis B/C type tilt-rotary can handle workpiece up to 300 kg 661 lb (0°~45°) / 200 kg 441 lb (45°~90°), enabling large working area for jig and fixture set-up.'
                            ],
                videoUrl:"https://www.youtube.com/watch?v=9xHFNXUiT_s&feature=youtu.be",
                // buttonVideoUrl:"https://www.google.com/",
                moreInfo:"https://www.ycmcnc.com/en/new/1533009146757/1644542174129",
                onlineDemo:"http://www.ycmcnc.com/_upload/files/UV_650_202009_E_low.pdf",
                // automation:"https://www.google.com/",
                specification:[
                        ['Spindle Speed (opt.)','12,000 (15,000) rpm'],
                        ['Max. Spindle Power (opt.)',<span>17 kW (17) <BlueText>23 (23) HP</BlueText></span>],
                        ['Spindle Taper','BBT40'],
                        ['X / Y / Z-axis',<span>620 / 520 / 460 mm<br/><BlueText>24.4" / 20.5" / 18.1"</BlueText></span>],
                        ['B / C-axis Rotation Range','-50°~ +110° / 360°'],
                        ['Table Size',<span>ø650 mm<br/><BlueText>ø25.6"</BlueText></span>],
                        ['Tool Magazine Capacity (opt.)','32 (40 / 48 / 60) T'],
                    ],
                // annotation:[
                //     ['The manufacturer reserves the right to modify the design, specifications, mechanisms, etc. to improve the performance of the machine without notice. All the specifications shown above are just for reference.'],
                // ],
            }
    },
    //DCV 2018A-5AX
    DCV2018A5AX:{
        ch:
            {   title:'DCV 2018A-5AX',
                subtitle:'高精度五軸龍門型立式綜合加工機',
                ar:'',
                machineImg:DCV2018A5AX,
                introduction:[  '高轉速18,000 rpm HSK A63主軸，適合長時間加工，有效降低主軸溫度，提供高精度高效率之加工性能。',
                                '一次裝夾即可，進行多工序五軸加工縮短加工時間。',
                                '主軸以B/C軸旋轉頭設計，採用無背隙直驅式馬達驅動，最高旋轉速度達 100 rev/min。',
                                'Y/Z軸採用滾珠螺桿，加上馬達採撓性直結設計，提供無背隙及更精確的定位精度。',
                                'Z軸採用高剛性滾柱線軌，搭配六滑塊及無配重設計，在3D曲面輪廓精度的表現特別優異。',
                                '高剛性一體成型肋骨底座，全行程支撐工作台，使工件載重最高可達8,000 kg。'
                            ],
                videoUrl:"https://www.youtube.com/watch?v=ngO1Z-rSPAM&feature=youtu.be",
                buttonVideoUrl:"https://www.youtube.com/watch?v=o1-I2EO6Xng&t=92s",
                moreInfo:"https://www.ycmcnc.com/product/1532483518786/1533199284229/1533778361681",
                onlineDemo:"https://www.ycmcnc.com/_upload/files/DCV_2019_C_low.pdf",
                specification:[
                        ['主軸轉速','18,000 rpm'],
                        ['最大主軸功率','70 kW'],
                        ['主軸端孔斜度','HSK A63'],
                        ['X / Y / Z軸行程','2,200 / 2,400 / 762 mm'],
                        ['B / C軸旋轉範圍','±105° / ±360°'],
                        ['工作台尺寸','2,000 × 1,500 mm'],
                        ['刀具數量(選擇)', '40 (60 / 120) T'],
                ],
                    // annotation:[
                    //     ['註：本公司隨時進行研究改進的工作，因此保有更改設計、規格功能之權利。'],
                    // ],
                
            },
        en:
            {   title:'DCV 2018A-5AX',
                subtitle:'5-Axis Double Column Vertical Machining Center',
                ar:'',
                machineImg:DCV2018A5AX,
                introduction:[  <span>HSK A63-taper spindle with 70 kW <BlueText>93.9 HP</BlueText> motor power allowing high metal removal rates.</span>,
                                'B/C-axis tilting spindle head with rotation speed up to 100 rev/min.',
                                'High precision ball screws on Y/Z-axis directly driven by servomotor.',
                                'Rigid roller type guideways and 6 slide blocks on Z-axis.',
                                <span>Max. workpiece load weighing up to 8,000 kg. <BlueText>17,637 lb.</BlueText></span>
                            ],
                videoUrl:"https://www.youtube.com/watch?v=ngO1Z-rSPAM&feature=youtu.be",
                buttonVideoUrl:"https://www.youtube.com/watch?v=cqaUj-GjOec",
                moreInfo:"https://www.ycmcnc.com/en/product/1532483518786/1533199284229/1533778361681",
                onlineDemo:"https://www.ycmcnc.com/_upload/files/DCV_E_201904.pdf",
                specification:[
                        ['Spindle Speed','18,000 rpm'],
                        ['Max. Spindle Power',<span>70 kW <BlueText>93.9 HP</BlueText></span>],
                        ['Spindle Taper','HSK A63'],
                        ['X / Y / Z-axis',<span>2,200 / 2,400 / 762 mm<br/><BlueText>86.6" / 94.5" / 30"</BlueText></span>],
                        ['B / C-axis Rotation Range','±105° / ±360°'],
                        ['Table Size',<span>2,000 × 1,500 mm<br/><BlueText>78.7" × 59.1"</BlueText></span>],
                        ['Tool Magazine Capacity(opt.)', '40 (60 / 120) T'],
                ],
                    // annotation:[
                    //     ['The manufacturer reserves the right to modify the design, specifications, mechanisms, etc. to improve the performance of the machine without notice. All the specifications shown above are just for reference.'],
                    // ],
            }
    },
    //BTX 250SY TBD
    BTX250SY_TBD:{
    ch:
        {   title:'BTX 250SY TBD',
            subtitle:'車銑複合車床',
            ar:'',
            machineImg:'',
            introduction:[  '30° 斜背式一體成形底座，精度高、誤差小，同時展現強力排屑特性。',
                            '搭配高剛性主軸設計，適合高速精密切削及低速重力切削。',
                            '搭配副主軸、Y軸、動力刀塔及C軸，整合車銑複合功能，一次即可完成棒材兩端加工，提升加工效率。'
                        ],
            videoUrl:"",
            buttonVideoUrl:"",
            moreInfo:"",
            onlineDemo:"",
            specification:[
                    ['床身/床鞍最大旋徑','ø1,000 / 870 mm'],
                    ['最大加工直徑/長度','ø350 / 728 mm'],
                    ['夾頭直徑','Main: 10" / Sub: 6"'],
                    ['拉桿通孔直徑','Main: ø75 mm  Sub: ø45 mm'],
                    ['主軸轉速/功率','Main: 3,500 rpm / 35 kW   Sub:  6,000 rpm / 11 kW'],
                    ['X / Y / Z / B 軸行程','260 / 780 / 100 (±50) / 760 mm'],
                    ['快速押送速度 (X / Z / Y / B)','20 / 24 / 10 / 20 m/min.'],
                    ['刀塔型式/ 刀塔刀具容量','BMT65 / 12T'],
                    ['外徑刀/內徑刀尺寸','ø25 mm / ø40 mm'],
                    ['控制器','FANUC TXP-200FB+'],
                ],
            
        },
    en:
        {   title:'BTX 250SY TBD',
            subtitle:'High Efficiency 10" Turn-Mill Center',
            ar:'',
            machineImg:'',
            introduction:[  'One-piece 30° slant bed design.',
                            'Turret index and rotation is controlled by servo motor, enabling reliable and fast tool index times.',
                            'Packed with sub spindle, Y-axis, live tool turret and C-axis, these turn-mill features allow complex finished parts machining in just one setup, while also improving efficiency and accuracy.'
                        ],
            videoUrl:"",
            buttonVideoUrl:"",
            moreInfo:"",
            onlineDemo:"",
            specification:[
                    ['Swing Over Bed / Carriage','ø1,000 / 870 mm　ø39.4" / 34.3"'],
                    ['Max. Turning Diameter / Length','ø350 / 729 mm　ø13.8" / 28.7"'],
                    ['Chuck Size','Main: 10" / Sub: 6"'],
                    ['Hole Through Draw Tube','Main: ø75 mm　ø3"Sub: ø45 mm　ø1.8"'],
                    ['Spindle Speed / Power','Main: 3,500 rpm / 35 kW　46.9 HP   Sub:  6,000 rpm / 11 kW　14.8 HP'],
                    ['X / Y / Z / B Travel','260 / 780 / 100 (±50) / 770 mm 10.2" / 30.7" / 3.9" (±2") / 30.3"'],
                    ['Rapid Feedrate (X / Z / Y / B)','20 / 24 / 10 / 20 m/min.787 / 945 / 394 / 787 ipm'],
                    ['Turret Tool Standard / Turret Capacity','BMT65 Live Turret / 12T'],
                    ['Shank Height for Square Tool / Shank Diameter for Boring Bar','ø25 mm / ø40 mm　ø1" / ø1 & 1/2"'],
                    ['Controller','FANUC TXP-200FB+'],
                ],
            
        }
    },
    //NXV 1270A
    NXV1270A:{
        ch:
            {   title:'NXV 1270A',
                subtitle:'高效率立式綜合加工機',
                ar:['Ar/iFrame/machineContent_NXV1270A_Ch.html',
                    'Ar/iFrame/machineShow_NXV1270A.html'],
                machineImg:NXV1270A,
                introduction:[  '三軸皆採用高剛性、高負荷滾柱線軌，確保軸向進給精度與耐久性。',
                                '鞍座雙重壁結構，X軸六滑塊設計，最大可負荷高達 1,500 kg 之工件。',
                                'Y軸採用四滑軌設計，加上全行程支撐，表現完美的動態水平精度。',
                                '標準搭配四螺旋捲屑裝置及鐵屑輸送機，排屑更流暢。'
                            ],
                videoUrl:"https://www.youtube.com/watch?v=l4IStyKjkWI&feature=youtu.be",
                buttonVideoUrl:"",
                moreInfo:"https://www.ycmcnc.com/new/1533009146757/1604019181704",
                onlineDemo:"",
                specification:[
                        ['主軸轉速(選擇)','12,000 (15,000) rpm'],
                        ['最大主軸功率(選擇)','18.5 (18.5) kW'],
                        ['主軸端孔斜度','BBT 40'],
                        ['X / Y / Z軸行程','1,270 / 660 / 620 mm'],
                        ['工作台尺寸','1,350 × 660 mm'],
                        ['刀具數量(選擇)','24 (30 / 40 / 60) T'],
                    ],
                // annotation:[
                //     ['註：本公司隨時進行研究改進的工作，因此保有更改設計、規格功能之權利。'],
                // ],
            },
        en:
            {   title:'NXV 1270A',
                subtitle:'Compact and Affordable Vertical Machining Center',
                ar:['Ar/iFrame/machineContent_NXV1270A_En.html',
                    'Ar/iFrame/machineShow_NXV1270A.html'],
                machineImg:NXV1270A,
                introduction:[  'Robust roller linear guideways applied on 3 axes.',
                                'Rigid dual-wall castings on saddle and 6 blocks design on X-axis can easily support workpieces weighing up to 1,500 kg. 3,306 lb.',
                                '4-linear guideways on Y-axis with superior large span ensures the best dynamic balance.',
                                'Quick and smooth chip discharge with quad-chip auger and chip conveyor provided as a standard.'
                            ],
                videoUrl:"https://www.youtube.com/watch?v=l4IStyKjkWI&feature=youtu.be",
                buttonVideoUrl:"",
                moreInfo:"https://www.ycmcnc.com/en/new/1533009146757/1604019181704",
                onlineDemo:"",
                specification:[
                        ['Spindle Speed (opt.)','12,000 (15,000) rpm'],
                        ['Max. Spindle Power (opt.)',<span>18.5 kW (18.5 kW) <br/><BlueText>25 HP (25 HP)</BlueText></span>],
                        ['Spindle Taper','BBT 40'],
                        ['X / Y / Z-axis',<span>1,270 / 660 / 620 mm<br/><BlueText>50" / 26" / 24.4"</BlueText></span>],
                        ['Table Size',<span>1,350 × 660 mm<br/><BlueText>53.2" × 26"</BlueText></span>],
                        ['Tool Magazine Capacity (opt.)','24 (30 / 40 / 60) T'],
                    ],
                // annotation:[
                //     ['The manufacturer reserves the right to modify the design, specifications, mechanisms, etc. to improve the performance of the machine without notice. All the specifications shown above are just for reference.'],
                // ],
            }
    },
    //NH 500AW 
    NH500AW :{
        ch:
            {   title:'NH 500AW',
                subtitle:'高生產力臥式綜合加工機',
                ar:'',
                machineImg:NH500AW,
                introduction:[  '三軸皆採用加大級距的滾柱線軌，並以AC伺服馬達驅動螺桿，快速進給速度可高達 60 m/min。',
                                '寬敞加工空間，可容納 ø800 × 1,000 mm 並負載 500 kg 之工件。',
                                '搭配底座高壓沖水，達到排屑高效率。',
                                'X/Z軸使用一片式伸縮護罩，水屑防護性更佳。'
                            ],
                videoUrl:"",
                buttonVideoUrl:"",
                moreInfo:"https://www.ycmcnc.com/new/1533009146757/1604654515218",
                onlineDemo:"",
                specification:[
                        ['主軸轉速','15,000 rpm'],
                        ['最大主軸功率','37 kW'],
                        ['主軸端孔斜度','BBT40'],
                        ['X / Y / Z 軸行程','800 / 730 / 800 mm'],
                        ['工作台尺寸','500 × 500 mm'],
                        ['刀具數量','40T'],
                ],
                // annotation:[
                //     ['註：本公司隨時進行研究改進的工作，因此保有更改設計、規格功能之權利。'],
                // ],  
            },
            en:
            {   title:'NH 500AW',
                subtitle:'High Production 2-Pallet Horizontal Machining Center',
                ar:'',
                machineImg:NH500AW,
                introduction:[  <span>High precision large-diameter roller type guideways on all axes with rapid feedrate up to 60 m/min. <BlueText>2,362 ipm.</BlueText></span>,
                                <span>Max. workpiece size of 800 × 1,000 mm <BlueText>31.5" × 39.4"</BlueText> with up to 500 kg <BlueText>1,102 lb</BlueText> weight.</span>,
                                'With high-pressure flushing of the base, high efficiency of chip removal is achieved.',
                                'The X/Z axis uses a one-piece telescopic shield for better water chip protection.'
                            ],
                videoUrl:"",
                buttonVideoUrl:"",
                moreInfo:"https://www.ycmcnc.com/en/new/1533009146757/1604654515218",
                onlineDemo:"",
                specification:[
                        ['Spindle Speed','15,000 rpm'],
                        ['Max. Spindle Power',<span>37 kW <BlueText>50 HP</BlueText></span>],
                        ['Spindle Taper','BBT40'],
                        ['X / Y / Z-axis',<span>800 / 730 / 800 mm<br/><BlueText>31.5" / 28.7" / 31.5"</BlueText></span>],
                        ['Table Size',<span>500 × 500 mm<br/><BlueText>19.7" × 19.7"</BlueText></span>],
                        ['Tool Magazine Capacity','40T'],
                ],
                // annotation:[
                //     ['The manufacturer reserves the right to modify the design, specifications, mechanisms, etc. to improve the performance of the machine without notice. All the specifications shown above are just for reference.'],
                // ],
            }
    },
    //NFP 66A
    NFP66A:{
        ch:
        {   title:'NFP 66A',
            subtitle:'高速精密立式加工機',
            ar:'',
            machineImg:NFP66A,
            introduction:[  '高剛性一體式門柱，結構對稱設計，有效減少熱變形，確保機器長時間的加工精度。',
                            '高性能內藏式主軸，有效降低振動，提供最佳表面處理，並有效延長刀具的使用年限。',
                            '獨特的高剛性底座，全行程支撐工作台，使工件載重最高可達500 kg。',
                            '完整熱對策，搭配光學尺，實現高精度定位及重覆精度，特別適合高精密微細加工。',
                        ],
            videoUrl:"https://www.youtube.com/watch?v=ZgLHLwhZeKY&feature=youtu.be",
            buttonVideoUrl:"",
            moreInfo:"https://www.ycmcnc.com/product/1532483518786/1533199189739/1533264764749",
            onlineDemo:"https://www.ycmcnc.com/_upload/files/NFP66A_C_202009_low.pdf",
            specification:[
                    ['主軸轉速(選擇)', '24,000 (40,000) rpm'],
                    ['最大主軸功率(選擇)', '22.5 (7.5) kW'],
                    ['主軸端孔斜度(選擇)', 'HSK-A63 (HSK-E40)'],
                    ['X / Y / Z軸行程','660 / 510 / 400 mm'],
                    ['工作台尺寸','800 × 510 mm'],
                    ['刀具數量','24T'],
            ],
            // annotation:[
            //     ['註：本公司隨時進行研究改進的工作，因此保有更改設計、規格功能之權利。'],
            // ],
            
        },
    en:
        {   title:'NFP 66A',
            subtitle:'Rigid Double Column with High Spindle Speed and Precision',
            ar:'',
            machineImg:NFP66A,
            introduction:[  'Rigid one-piece column ensures high stiffness and rigidity that results in superior thermal stability, and cutting performance.',
                            'Built-in spindle offers vibration dampening, fine surface finishes and long tool life.',
                            <span>Max. workpiece load weighing up to 500 kg. <BlueText>1,102 lb.</BlueText></span>,
                            'Complete thermal solution and rotary encoders ensure high resolution positioning and repeatability.',
                        ],
            videoUrl:"https://www.youtube.com/watch?v=ZgLHLwhZeKY&feature=youtu.be",
            buttonVideoUrl:"",
            moreInfo:"https://www.ycmcnc.com/en/product/1532483518786/1533199189739/1533264764749",
            onlineDemo:"https://www.ycmcnc.com/_upload/files/NFP66A_E_202009_low.pdf",
            specification:[
                    ['Spindle Speed (opt.)', '24,000 (40,000) rpm'],
                    ['Max. Spindle Power (opt.)', <span>22.5 (7.5) kW <BlueText>30 (10) HP</BlueText></span>],
                    ['Spindle Taper (opt.)', 'HSK-A63 (HSK-E40)'],
                    ['X / Y / Z-axis',<span>660 / 510 / 400 mm<br/><BlueText>26" / 20.1" / 15.8"</BlueText></span>],
                    ['Table Size',<span>800 × 510 mm<br/><BlueText>31.5" × 20.1"</BlueText></span>],
                    ['Tool Magazine Capacity','24T'],
            ],
            // annotation:[
            //     ['The manufacturer reserves the right to modify the design, specifications, mechanisms, etc. to improve the performance of the machine without notice. All the specifications shown above are just for reference.'],
            // ],
        }
    },
    //NXV 600A
    NXV600A:{
        ch:
            {   title:'NXV 600A',
                subtitle:'高效率立式綜合加工機',
                ar:'',
                machineImg:NXV600A,
                introduction:[  '主軸採用直結傳動設計，提高加工效率與工件品質。',
                                '三軸皆採用以伺服馬達直結驅動滾珠螺桿，提供無背隙及精確的定位精度，快速進給速度更可高達48 m/min。',
                                '寬敞的加工範圍，最大可負載 300 kg 之工件。',
                                '搭配先進的超音波加工技術，可輕易加工高硬度及脆性材料。',
                            ],
                videoUrl:"https://www.youtube.com/watch?v=IuHP8Tn_L20&feature=youtu.be",
                buttonVideoUrl:"https://www.youtube.com/watch?v=0oLF-Cc_sHY",
                moreInfo:"https://www.ycmcnc.com/product/1532483505262/1533187228807/1533697379287",
                onlineDemo:"https://www.ycmcnc.com/_upload/files/NXV_C_2019_low.pdf",
                specification:[
                        ['主軸轉速(選擇)', '12,000 (15,000) rpm'],
                        ['最大主軸功率(選擇)', '18.5 kW (18.5 kW)'],
                        ['主軸端孔斜度','BBT40'],
                        ['X / Y / Z軸行程','600 / 410 / 450 mm'],
                        ['工作台尺寸','700 × 420 mm'],
                        ['刀具數量','24T'],
                ],
                // annotation:[
                //     ['註：本公司隨時進行研究改進的工作，因此保有更改設計、規格功能之權利。'],
                // ],
                
        },
        en:
            {   title:'NXV 600A',
                subtitle:'High Productivity Vertical Machining Center',
                ar:'',
                machineImg:NXV600A,
                introduction:[  'Direct drive spindle with low vibration to achieve excellent finish.',
                                <span>All 3 axes with direct drive design and absolute positioning encoders, achieving rapid feedrate up to 48 m/min. <BlueText>1,890 ipm.</BlueText></span>,
                                <span>Max. workpiece load weighing up to 300 kg. <BlueText>660 lb.</BlueText></span>,
                                'Optional ultrasonic tool holder for hard and brittle materials.'
                            ],
                videoUrl:"https://www.youtube.com/watch?v=IuHP8Tn_L20&feature=youtu.be",
                buttonVideoUrl:"https://www.youtube.com/watch?v=N1_DdS91k40",
                moreInfo:"https://www.ycmcnc.com/en/product/1532483505262/1533187228807/1533697379287",
                onlineDemo:"https://www.ycmcnc.com/_upload/files/NXV_E_201905_low.pdf",
                specification:[
                        ['Spindle Speed (opt.)', '12,000 (15,000) rpm'],
                        ['Max. Spindle Power (opt.)', <span>18.5 kW (18.5 kW) <BlueText>25 (25) HP</BlueText></span>],
                        ['Spindle Taper','BBT40'],
                        ['X / Y / Z-axis',<span>600 / 410 / 450 mm<br/><BlueText>23.6" / 16.1" / 17.7"</BlueText></span>],
                        ['Table Size',<span>700 × 420 mm<br/><BlueText>27.6" × 16.5"</BlueText></span>],
                        ['Tool Magazine Capacity','24T'],
                ],
                // annotation:[
                //     ['The manufacturer reserves the right to modify the design, specifications, mechanisms, etc. to improve the performance of the machine without notice. All the specifications shown above are just for reference.'],
                // ],
                
            }
    },
    //DCV 2018B-5AX
    DCV2018B5AX:{
    ch:
        {   title:'DCV 2018B-5AX',
            subtitle:'高精度五軸龍門型立式綜合加工機',
            ar:'',
            machineImg:DCV2012B,
            introduction:[  '高轉速 16,000 rpm HSK A100 主軸，適合長時間加工，有效降低主軸溫度，提供高精度高效率之加工性能。',
                            '一次裝夾作業，進行多工序五軸加工縮短加工時間。',
                            '主軸以B/C軸旋轉頭設計，採用無背隙直驅式馬達驅動，最高旋轉速度達 100 rev/min。',
                            'Y/Z軸採用滾珠螺桿，加上馬達採撓性直結設計，提供無背隙及更精確的定位精度。',
                            'Z軸採用高剛性滾柱線軌，搭配六滑塊及無配重設計，在3D曲面輪廓精度的表現特別優異。',
                            '高剛性一體成型肋骨底座，全行程支撐工作台，使工件載重最高可達 8,000 kg。'
                        ],
            videoUrl:"",
            buttonVideoUrl:"",
            moreInfo:"https://www.ycmcnc.com/new/1533009146757/1604282164319",
            onlineDemo:"",
            specification:[
                    ['主軸轉速','16,000 rpm'],
                    ['最大主軸功率','40 kW'],
                    ['主軸端孔斜度','HSK A100'],
                    ['X / Y / Z軸行程','2,200 / 2,400 / 762 mm'],
                    ['B / C軸旋轉範圍 ','±110° / ±360°'],
                    ['工作台尺寸','2,000 × 1,500 mm'],
                    ['刀具數量(選擇)','40 (60) T'],
                ],
            // annotation:[
            //     ['註：本公司隨時進行研究改進的工作，因此保有更改設計、規格功能之權利。'],
            // ],
        },
    en:
        {   title:'DCV 2018B-5AX',
            subtitle:'5-Axis Double Column Vertical Machining Center',
            ar:'',
            machineImg:DCV2012B,
            introduction:[  <span>HSK A100-taper spindle with 40 kＷ <BlueText>53.6 HP</BlueText> motor power allowing high metal removal rates.</span>,
                            'B/C-axis tilting spindle head with rotation speed up to 100 rev/min.',
                            'High precision ball screws on Y/Z-axis directly driven by servomotor.',
                            'Rigid roller type guideways and 6 slide blocks on Z-axis.',
                            <span>Max. workpiece load weighing up to 8,000 kg. <BlueText>17,637 lb.</BlueText></span>
                        ],
            videoUrl:"",
            buttonVideoUrl:"",
            moreInfo:"https://www.ycmcnc.com/en/new/1533009146757/1604282164319",
            onlineDemo:"",
            specification:[
                    ['Spindle Speed','16,000 rpm'],
                    ['Max. Spindle Power',<span>40 kW <BlueText>53.6 HP</BlueText></span>],
                    ['Spindle Taper','HSK A100'],
                    ['X / Y / Z-axis',<span>2,200 / 2,400 / 762 mm<br/><BlueText>86.6" / 94.5" / 30"</BlueText></span>],
                    ['B / C-axis Rotation Range','±110° / ±360°'],
                    ['Table Size',<span>2,000 × 1,500 mm<br/><BlueText>78.7" × 59.1"</BlueText></span>],
                    ['Tool Magazine Capacity (opt.)','40 (60) T'],
                ],
            // annotation:[
            //     ['The manufacturer reserves the right to modify the design, specifications, mechanisms, etc. to improve the performance of the machine without notice. All the specifications shown above are just for reference.'],
            // ],
        }
    },
    //NSV 106AS
    NSV106AS:{
        ch:
        {   title:'NSV 106AS',
            subtitle:'超高效能立式綜合加工機',
            ar:'',
            machineImg:NSV106AS,
            introduction:[  '大立柱與底座設計，提升加工精度的高穩定性。',
                            '超寬滑道跨距。',
                            '搭配精密滾柱線軌及大直徑滾珠螺桿。',
                            '極高控制性及穩定性精度。',
                            '先進FEM嚴格分析，全新強化機體結構設計，展現超高切削效能與加工穩定性，滿足高精度模具加工的嚴苛需求。'
                        ],
            videoUrl:"https://www.youtube.com/watch?v=X4wo1LPB4sM&feature=youtu.be",
            buttonVideoUrl:"https://www.youtube.com/watch?v=YssQSB9cC98&feature=youtu.be",
            moreInfo:"https://www.ycmcnc.com/product/1532483505262/1533181774594/1534726457012",
            onlineDemo:"https://www.ycmcnc.com/_upload/files/NSV106A.AM_C_%E6%96%B0%E9%88%91%E9%87%91_L.pdf",
            specification:[
                    ['主軸轉速 (選擇)','15,000 rpm'],
                    ['最大主軸功率 (選擇)','30 kW'],
                    ['主軸端孔斜度','BBT40'],
                    ['X / Y / Z 軸行程','1,020 / 600 / 600 mm'],
                    ['工作台尺寸','1,120 × 650 mm'],
                    ['刀具數量 (選擇)', '30 (48) T'],
                ],
            // annotation:[
            //     ['註：本公司隨時進行研究改進的工作，因此保有更改設計、規格功能之權利。'],
            // ],
        },
        en:
        {   title:'NSV 106AS',
            subtitle:<span>Ultra High Performance<br/>Vertical Machining Center</span>,
            ar:'',
            machineImg:NSV106AS,
            introduction:[  'Large delta machine column and base ensure the highest stability during high speed movement.',
                            'Wide span of axial guideways.',
                            'Wide ball screws and high precision roller type guideways on all axes.',
                            'Reinforced body structure through FEM analysis and durable MEEHANITE casting strengthening the body to combat structure deformation when under stress.'
                        ],
            videoUrl:"https://www.youtube.com/watch?v=X4wo1LPB4sM&feature=youtu.be",
            buttonVideoUrl:"https://www.youtube.com/watch?v=spVVzfVvAgQ&t=235s",
            moreInfo:"https://www.ycmcnc.com/en/product/1532483505262/1533181774594/1534726457012",
            onlineDemo:"https://www.ycmcnc.com/_upload/files/NSV106A.AM_E_%E6%96%B0%E9%88%91%E9%87%91_L.pdf",
            specification:[
                    ['Spindle Speed','15,000 rpm'],
                    ['Max. Spindle Power', <span>30 kW <BlueText>40 HP</BlueText></span>],
                    ['Spindle Taper','BBT40'],
                    ['X / Y / Z-axis',<span>1,020 / 600 / 600 mm<br/><BlueText>40.2" / 23.6" / 23.6"</BlueText></span>],
                    ['Table Size',<span>1,120 x 650 mm<br/><BlueText>44" x 25.6"</BlueText></span>],
                    ['Tool Magazine Capacity (opt.)', '30 (48) T'],
            ],
            // annotation:[
            //     ['The manufacturer reserves the right to modify the design, specifications, mechanisms, etc. to improve the performance of the machine without notice. All the specifications shown above are just for reference.'],
            // ],
            }
    },
    //NTC2000LSY
    NTC2000LSY:{
        ch:
        {   title:'NTC-2000LSY',
            subtitle:'高效率複合車床',
            ar:'',
            machineImg:NTC2000LSY,
            introduction:[  'Y軸加C軸進行較複雜外型加工。',
                            '主軸大通孔設計，可通過直徑 ø66 mm 之棒材。',
                            '模組化設計，可依加工需求，選擇不同尺寸之主軸搭配刀塔、尾座或副主軸。',
                        ],
            videoUrl:"https://www.youtube.com/watch?v=22AQSd316YQ",
            buttonVideoUrl:"",
            moreInfo:"https://www.ycmcnc.com/product/1532483529953/1534481374369/1533633060016",
            onlineDemo:"https://www.ycmcnc.com/_upload/files/Turning%20Center%20Brochure_C_202006_low_.pdf",
            specification:[
                    ['床身/床鞍最大旋徑','ø710 / ø545 mm'],
                    ['最大加工直徑/長度','ø310 / 570 mm'],
                    ['主軸轉速','5,000 rpm '],
                    ['主軸馬達功率','18.5 (連續) / 22 (30 min) / 30 (S3-25%) kW'],
                    ['外徑刀/內徑刀尺寸','ø20 / ø32 mm'],
                    ['行程 (X / Z / Y / B)','160 (155+5) / 570 / 90 (+50/-40) / 650 mm'],
                    ['快速押送速度 (X / Z / Y / B)','30 / 36 / 10 / 20 m/min.'],
                    ['刀座型式/刀塔刀具容量(選擇)','BMT55 / (12T)'],
                    ['動力刀具馬達功率','1.1 (連續) / 3.7 (10 min) kW'],
                    ['旋轉刀具速度','4,000 rpm'],
                    ['第一工件/第二工件主軸夾頭直徑','8" / 6"'],
                    ['第一工件/第二工件主軸拉桿通孔直徑','ø66 / ø45 mm'],
                ],
            // annotation:[
            //     ['註：本公司隨時進行研究改進的工作，因此保有更改設計、規格功能之權利。'],
            // ],
        },
        en:
        {   title:'NTC-2000LSY',
            subtitle:'High Efficiency CNC Turning Center',
            ar:'',
            machineImg:NTC2000LSY,
            introduction:[  'Y plus C-axis integrates mill/turn process',
                            <span>High precision spindle with hole through draw bar for bars of ø66 mm <BlueText>ø2.6"</BlueText></span>,
                            'Modular design for multiple choices, including turret, tailstock, and sub spindle.',
                        ],
            videoUrl:"https://www.youtube.com/watch?v=22AQSd316YQ",
            buttonVideoUrl:"",
            moreInfo:"https://www.ycmcnc.com/en/product/1532483529953/1534481374369/1533633060016",
            onlineDemo:"https://www.ycmcnc.com/_upload/files/Turning%20Center%20Brochure_E_202006_low_.pdf",
            specification:[
                    ['Swing Over Bed / Carriage ',<span>ø710 / ø545 mm<br/><BlueText>ø27.9" / ø21.5"</BlueText></span>],
                    ['Max. Turning Diameter / Length',<span>ø310 / 570 mm<br/><BlueText>ø12.2" / 22.4"</BlueText></span>],
                    ['Max. Spindle Speed ','5,000 rpm'],
                    ['Motor Power',<span>18.5 (cont.) / 22 (30min) / 30 (S3-25%) kW <br/><BlueText>25 (cont.) / 30 (30min) / 40 (S3-25%) HP</BlueText></span>],
                    ['Shank Height for Square Tool/ Boring Bar',<span>ø20 / ø32 mm<br/><BlueText>ø3/4" / ø1&1/4"</BlueText></span>],
                    ['Travel (X / Z / Y / B)',<span>160 (155+5) / 570 / 90 (+50/-40) / 650 mm<br/><BlueText>6.3"(6.1"+0.2") / 22.4" / 3.5" (+1.97" / -1.57") / 25.6"</BlueText></span>],
                    ['Rapid Feedrate (X / Z / Y / B)',<span>30 / 36 / 10 / 20 m/min. <BlueText>1,181 / 1,417 / 394 / 787 ipm</BlueText></span>],
                    [' Turret / Tool Magazine Capacity(opt.)Turret / Tool Magazine Capacity','BMT 55 / (12T)'],
                    ['Motor',<span>1.1 (cont.) / 3.7 (10min) kW <br/><BlueText>1.5 (cont.) / 4.96 (10min) HP</BlueText></span>],
                    ['Live Tool Speed','4,000 rpm'],
                    ['Chuck Size / Sub Spindle','8" / 6"'],
                    ['Hole Through Draw Tube / Sub Spindle',<span>ø66 / ø45 mm<br/><BlueText>ø2.6" / ø1.77"</BlueText></span>],
            ],
            // annotation:[
            //     ['The manufacturer reserves the right to modify the design, specifications, mechanisms, etc. to improve the performance of the machine without notice. All the specifications shown above are just for reference.'],
            // ],
        }
    },
    //NSV 106AMS
    NSV106AMS:{
        ch:
        {   title:'NSV 106AMS',
            subtitle:'超高效能立式綜合加工機',
            ar:'',
            machineImg:NSV106AMS,
            introduction:[  '大立柱與底座設計穏定高速移動精度。',
                            '超寬滑道跨距。',
                            '搭配精密線性滑軌及大直徑滾珠螺桿。',
                            '極高控制性及穩定性精度。',
                            '先進FEM嚴格分析，全新強化機體結構設計，展現超高切削效能與加工穩定性，滿足高精度模具加工的嚴苛需求。'
                        ],
            videoUrl:"https://www.youtube.com/watch?v=OELBiLP8pmU&t=1s",
            buttonVideoUrl:"https://www.youtube.com/watch?v=YssQSB9cC98&feature=youtu.be",
            moreInfo:"https://www.ycmcnc.com/product/1532483505262/1533181774594/1534727225710",
            onlineDemo:"https://www.ycmcnc.com/_upload/files/NSV106A.AM_C_%E6%96%B0%E9%88%91%E9%87%91_L.pdf",
            specification:[
                    ['主軸轉速(選擇)','12,000 (15,000) rpm'],
                    ['最大主軸功率(選擇)','22 (30) kW'],
                    ['主軸端孔斜度','BBT40'],
                    ['X / Y / Z軸行程','1,020 / 600 / 600 mm'],
                    ['工作台尺寸','1,120 x 650 mm'],
                    ['刀具數量(選擇)','24 (30 / 48) T'],
                ],
            // annotation:[
            //     ['註：本公司隨時進行研究改進的工作，因此保有更改設計、規格功能之權利。'],
            // ],
        },
        en:
        {   title:'NSV 106AMS',
            subtitle:'Ultra High Performance Vertical Machining Center',
            ar:'',
            machineImg:NSV106AMS,
            introduction:[  'Large delta machine column and base ensure the highest stability during high speed movement.',
                            'Wide span of axial guideways.',
                            'Wide ball screws and high precision linear guideways on all axes.',
                            'Reinforced body structure through FEM analysis and durable MEEHANITE casting strengthening the body to combat structure deformation when under stress.'
                        ],
            videoUrl:"https://www.youtube.com/watch?v=OELBiLP8pmU&t=1s",
            buttonVideoUrl:"https://www.youtube.com/watch?v=spVVzfVvAgQ&t=235s",
            moreInfo:"https://www.ycmcnc.com/en/product/1532483505262/1533181774594/1534727225710",
            onlineDemo:"https://www.ycmcnc.com/_upload/files/NSV106A.AM_E_%E6%96%B0%E9%88%91%E9%87%91_L.pdf",
            specification:[
                    ['Spindle Speed (opt.)','12,000 (15,000) rpm'],
                    ['Max. Spindle Power (opt.)',<span>22 (30) kW <BlueText>29.5 (40) HP</BlueText></span>],
                    ['Spindle Taper','BBT40'],
                    ['X / Y / Z-axis',<span>1,020 / 600 / 600 mm<br/><BlueText>40.2" / 23.6" / 23.6"</BlueText></span>],
                    ['Table Size',<span>1,120 x 650 mm<br/><BlueText>44" x 25.6"</BlueText></span>],
                    ['Tool Magazine Capacity (opt.)','24 (30 / 48) T'],
                ],
            // annotation:[
            //     ['The manufacturer reserves the right to modify the design, specifications, mechanisms, etc. to improve the performance of the machine without notice. All the specifications shown above are just for reference.'],
            // ],
        }
    },
}

const annotationConfig = {
    ch:'註：本公司隨時進行研究改進的工作，因此保有更改設計、規格功能之權利。',
    en:'The manufacturer reserves the right to modify the design, specifications, mechanisms, etc. to improve the performance of the machine without notice. All the specifications shown above are just for reference.'
}

export {machineConfig,annotationConfig};